<form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="" novalidate autocomplete="off">
    <div class="row gy-4">
        <div class="col-md-6">
            <input type="text" class="form-control" placeholder="Your Name*" formControlName="name"
                [ngClass]="{'is-invalid': contactForm.get('name')?.invalid && (contactForm.get('name')?.touched) }" />
        </div>

        <div class="col-md-6">
            <input id="email" type="email" class="form-control" placeholder="Your Email*" formControlName="email"
                [ngClass]="{ 'is-invalid': contactForm.get('email')?.invalid && (contactForm.get('email')?.touched) }" />
        </div>

        <div class="col-md-12">
            <input type="text" class="form-control" placeholder="Subject*" formControlName="subject"
                [ngClass]="{ 'is-invalid': contactForm.get('subject')?.invalid && (contactForm.get('subject')?.touched)}" />
        </div>

        <div class="col-md-12">
            <textarea class="form-control" rows="6" placeholder="Message*" formControlName="message"
                [ngClass]="{ 'is-invalid': contactForm.get('message')?.invalid && (contactForm.get('message')?.touched) }"></textarea>
        </div>

        <div class="col-md-12 text-center">
            @if (isLoading) {
            <div class="loading">Loading...</div>
            }

            @if (isError) {
            <div class="error-message">{{ errorMsg }}</div>
            }

            @if (isSuccess) {
            <div class="sent-message">
                Your message has been sent. Thank you!
            </div>
            }

            <button type="submit" class="btn btn-get-started w-100" [disabled]="contactForm.invalid">
                Send Message
            </button>
        </div>
    </div>
</form>